import * as yup from 'yup'
import { INCORRECT_VERIFICATION_CODE, LOCATION_INVALID, TYPE_REQUIRED, TYPE_UNMATCHED_SSN } from 'constants/errors'
import { zipCodeSchema } from 'helpers/schemaHelpers'

export const addressFormSchema = yup.object().shape({
  address1: yup.string().required(TYPE_REQUIRED),
  address2: yup.string(),
  city: yup.mixed().required(LOCATION_INVALID).test(
    'location-check', LOCATION_INVALID, (val: any) => Boolean(val && val.value)
  ).typeError(LOCATION_INVALID),
  zip5: zipCodeSchema,
})

export const ssnFormSchema = yup.object().shape({
  ssn: yup.string().required(TYPE_REQUIRED),
  ssn2: yup.string().test('passwords-match', TYPE_UNMATCHED_SSN, function () {
    return this.parent.ssn === this.parent.ssn2
  }),
})

export const phoneFormSchema = yup.object().shape({
  phone_number: yup.string()
    .required(TYPE_REQUIRED)
    .matches(/^\(\d{3}\) \d{3} - \d{4}$/, 'Invalid phone number'),
})

export const phoneVerifyFormSchema = yup.object().shape({
  verification_code: yup.string()
    .required(TYPE_REQUIRED)
    .matches(/^\d{4}$/, INCORRECT_VERIFICATION_CODE),
})


export const CC_ONBOARDING_FORM_ADDRESS = 'cc-onboarding-address' as const
export const CC_ONBOARDING_FORM_PHONE = 'cc-onboarding-phone' as const
export const CC_ONBOARDING_FORM_PHONE_VERIFY = 'cc-onboarding-phone-verify' as const
export const CC_ONBOARDING_FORM_SSN = 'cc-onboarding-ssn' as const
